export const toUpperCase = (str) => {
    return str.toUpperCase();
}

export const isBlob = (str) => {
    var MyBlob = new Blob([str], {type : 'text/plain'});
    console.log(MyBlob instanceof Blob) // true
    return MyBlob instanceof Blob;
}